<template lang="pug">
  .abilityGroup
    p.abilityGroup__title 司機相關
    .abilityGroup__item
      span.abilityGroup__subtitle 司機資料新增
      BaseAbilityRadioGroup(
        :value="abilityAddDriver"
        :disabled="disabled"
        @handleRadioChange="setAbilityAddDriver")
    .abilityGroup__item
      span.abilityGroup__subtitle 司機詳細頁面
      BaseAbilityRadioGroup(
        :value="abilityEditDriver"
        :disabled="disabled"
        @handleRadioChange="setAbilityEditDriver")
    .abilityGroup__item
      span.abilityGroup__subtitle 預設司機服務內容
      BaseAbilityRadioGroup(
        :value="abilityDriverService"
        :disabled="disabled"
        @handleRadioChange="setAbilityDriverService")
    .abilityGroup__item
      span.abilityGroup__subtitle 車輛監控
      BaseAbilityRadioGroup(
        :value="abilityDriverMonitor"
        :disabled="disabled"
        :uneditableAbility="true"
        @handleRadioChange="setAbilityDriverMonitor")
    .abilityGroup__item
      span.abilityGroup__subtitle 行車軌跡
      BaseAbilityRadioGroup(
        :value="abilityDriverTrajectory"
        :disabled="disabled"
        :uneditableAbility="true"
        @handleRadioChange="setAbilityDriverTrajectory")
    .abilityGroup__item
      span.abilityGroup__subtitle 司機訊息
      BaseAbilityRadioGroup(
        :value="abilityDriverMessage"
        :disabled="disabled"
        @handleRadioChange="setAbilityDriverMessage")
</template>
<script>
import BaseAbilityRadioGroup from '@/components/common/select/BaseAbilityRadioGroup'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters({
      abilityAddDriver: 'positionStore/getCurrentAbilityAddDriver',
      abilityEditDriver: 'positionStore/getCurrentAbilityEditDriver',
      abilityDriverService: 'positionStore/getCurrentAbilityDriverService',
      abilityDriverMonitor: 'positionStore/getCurrentAbilityDriverMonitor',
      abilityDriverTrajectory:
        'positionStore/getCurrentAbilityDriverTrajectory',
      abilityDriverMessage: 'positionStore/getCurrentAbilityDriverMessage',
    }),
  },
  methods: {
    ...mapActions({
      setAbilityAddDriver: 'positionStore/setAbilityAddDriver',
      setAbilityEditDriver: 'positionStore/setAbilityEditDriver',
      setAbilityDriverService: 'positionStore/setAbilityDriverService',
      setAbilityDriverMonitor: 'positionStore/setAbilityDriverMonitor',
      setAbilityDriverTrajectory: 'positionStore/setAbilityDriverTrajectory',
      setAbilityDriverMessage: 'positionStore/setAbilityDriverMessage',
    }),
  },
  components: {
    BaseAbilityRadioGroup,
  },
}
</script>
<style lang="scss" scoped>
@import 'src/scss/_abilityGroup';
</style>



// WEBPACK FOOTER //
// src/pages/manager/AbilityRadioGroup/AbilityGroupDriverItems.vue